import React from 'react';

export default function PageLoader(props) {
    return (
        <div className="page-loader">
            <div className="loading-overlay"></div>
        </div>
    );
}